<div class="no-content d-flex flex-column align-items-center" [class.compact]="compact" [class.text-only-on-phone]="textOnlyOnPhone">
  <img src="../../../assets/images/no-content.svg" alt="No Result Icon" class="img-fluid" />
  <p>
    {{messageKey | translate}}
    <button
      type="button"
      class="empty-clear-link"
      *ngIf="compact && filtersActive"
      (click)="onClearFiltersClick()">{{"TABLES.CLEAR_FILTERS" | translate}}</button>
  </p>
</div>
